import React from 'react';
import AuthContent from './layout/AuthContent';
import LoginForm from './auth/LoginForm';

const Login = () => {
    return (
        <AuthContent 
            component={LoginForm}
        />
    );
};

export default Login;